import { createSlice } from '@reduxjs/toolkit';
import { setIsLoading } from '../Loader/LoaderSlice';
import { setApiError } from '../Error/ErrorSlice';
import { fireApi } from '../../../utils/FireApi';
import { RevenueApi } from '../../../utils/Apis';
import { resetStore } from '../../Actions';

const initialState = {
  list_data: null,
  view_data: null,
  partner_details: null
};

const RevenueSlice = createSlice({
  name: 'Revenue',
  initialState,
  reducers: {
    setRevenueGrid(state, action) {
      state.list_data = action.payload;
    },
    setRevenueView(state, action) {
      state.view_data = action.payload;
    },
    setRevenuePartner(state, action) {
      state.partner_details = action.payload;
    },
    setCommentLogs(state, action) {
      state.comment_log = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState); // clear store
  }
});

// Revenue List
export const getRevenueGridList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: RevenueApi?.revenueList,
      method: 'post',
      payload: data
    });
    dispatch(setIsLoading({ loading: false }));
    // 🔹 Handle success
    if (res?.success) {
      dispatch(setRevenueGrid(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setRevenueGrid(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Revenue List failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Revenue List exception rrrrr', error);
    return null;
  } finally {
    // dispatch(setIsLoading({ loading: false }));
  }
};

export const getMisMatchedDownloadList = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: RevenueApi?.revenueMisMatchDownload,
      method: 'post',
      payload: data
    });

    console.log('sss match slice', res);
    return res;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};
// Revenue View
export const getRevenueViewData = (data) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: RevenueApi?.revenueViewFile,
      method: 'post',
      payload: data
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setRevenueView(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setRevenueView(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Revenue View failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Revenue View exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Revenue Partner Details
export const getRevenuePartnerDetails = () => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: RevenueApi?.revenuePartnerDetails
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setRevenuePartner(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setRevenuePartner(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Revenue Partner Details failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Revenue Partner Details exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

// Revenue Partner Details
export const getRevenueCommentLogs = (id) => async (dispatch) => {
  dispatch(setIsLoading({ loading: true }));
  try {
    const res = await fireApi({
      endpoint: RevenueApi?.commentLogs(id)
    });

    // 🔹 Handle success
    if (res?.success) {
      dispatch(setCommentLogs(res?.data?.data ? res?.data?.data : res?.data)); // store in redux
      return res?.data;
    } else {
      dispatch(setCommentLogs(null)); // store in redux
      dispatch(setApiError(res?.message || 'Something went wrong'));
      console.error('❌ Revenue Partner Details failed rrrrr', res?.data?.error);
      return null;
    }
  } catch (error) {
    dispatch(setApiError('Something went wrong'));
    console.error('🔥 Revenue Partner Details exception rrrrr', error);
    return null;
  } finally {
    dispatch(setIsLoading({ loading: false }));
  }
};

export const { setRevenueGrid, setRevenueView, setRevenuePartner, setCommentLogs } =
  RevenueSlice.actions;
export default RevenueSlice.reducer;
